export default __webpack_public_path__ + "static/hummingbird-01e9517ed4c6717b01c812b0684e9f45.png";